<template>
  <article>
    <!-- Close menu when clicking outside -->
    <div v-if="hamburgerOpen" class="overlay" @click="closeHamburger"></div>

    <section class="top-nav-mobile">
      <div class="logo-container">
        <router-link to="/">
          <img src="@/assets/logo/tahdik-logo-trans.png" alt="Tahdik Logo" class="logo" />
        </router-link>
      </div>
      <div
        v-if="!desktop"
        @click="openHamburger"
        class="hamburger-menu"
        :class="{ open: hamburgerOpen }"
      >
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
    </section>

    <!-- Mobile Navigation -->
    <Transition name="slide">
      <article v-if="hamburgerOpen" class="mobile-nav">
        <nav>
          <router-link
            v-for="page in pages"
            :key="page.name"
            :to="page.path"
            @click="closeHamburger"
            >{{ page.name }}</router-link
          >
        </nav>

        <hr />

        <div class="menu-contact-info">
          <p>
            <a
              class="map-link"
              href="https://maps.app.goo.gl/ZaxFRVLS4XzbMsML9"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bartoklaan 21, 3533 JA Utrecht
            </a>
          </p>
          <p>
            <a class="phone-link" href="tel:+0031634161665">06 34 16 16 65</a>

            <a class="phone-link" href="tel:+31302021863">031 30 20 21 863</a>
          </p>

          <p>
            <a class="email-link" href="mailto:info@tahdik.nl">info@tahdik.nl</a>
          </p>
        </div>

        <hr />

        <div class="social-media">
          <a
            href="https://www.facebook.com/TahdikRestaurant"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <font-awesome-icon icon="fa-brands fa-facebook-f" />
          </a>
          <a
            href="https://www.instagram.com/tahdikrestaurant/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <font-awesome-icon icon="fa-brands fa-instagram" />
          </a>
          <a
            href="whatsapp://send?phone=+31302021863&text=Hello%2C%20I%20would%20like%20to%20make%20a%20reservation."
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <font-awesome-icon icon="fa-brands fa-whatsapp-square" />
          </a>
        </div>
      </article>
    </Transition>

    <!-- Desktop Navigation -->
    <nav v-if="desktop" class="desktop-nav">
      <router-link v-for="page in pages" :key="page.name" :to="page.path" exact>{{
        page.name
      }}</router-link>
    </nav>
  </article>
</template>

<script>
export default {
  name: "Navi-gatie",
  created() {
    this.viewScreen();
    window.addEventListener("resize", () => {
      this.viewScreen();
    });
  },
  data() {
    return {
      message: "Hello from Navigatie component!",
      currentPage: window.location.pathname,
      widthOfPage: "",
      desktop: null,
      mobile: null,
      tablet: null,
      hamburgerOpen: false,
    };
  },
  props: {},
  methods: {
    viewScreen() {
      this.widthOfPage = window.innerWidth + "px";
      // console.log(this.widthOfPage);
      if (parseInt(this.widthOfPage) < 768) {
        this.desktop = false;
        this.mobile = true;
      } else {
        this.desktop = true;
        this.mobile = false;
      }
    },
    openHamburger() {
      this.hamburgerOpen = !this.hamburgerOpen;
    },
    closeHamburger() {
      this.hamburgerOpen = false;
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.viewScreen();
    });

    this.viewScreen();
  },
  unmounted() {
    window.removeEventListener("resize", () => {
      this.viewScreen();
    });
  },
};
</script>

<style scoped>
nav {
  font-family: "Poltawski Nowy", "Arial Narrow", Arial, sans-serif;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: center;
}

/* Styling for router-link */
a {
  text-decoration: none;
}

a:hover,
a.router-link-exact-active {
  color: var(--accent-orange);
}

a:hover::after,
a.router-link-exact-active::after {
  width: 100%;
}

.top-nav-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid var(--accent-orange);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.mobile-nav {
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--accent-blue) 100%);
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100%;
  padding: 1rem 2rem;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 1.4rem;
  text-align: center;
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  align-content: center;
  z-index: 9;
}

.mobile-nav a {
  display: block;
  padding: 0.2rem 0;
  font-weight: 500;
  /* border-bottom: 1px solid var(--primary-color); */
  transition: all 0.3s ease;
  text-transform: uppercase;
  color: var(--accent-twee);
  margin-bottom: 1rem;
}

.mobile-nav a:hover,
.mobile-nav a.router-link-exact-active {
  background-color: var(--accent-twee);
  padding: 1rem 0;
  color: var(--text-color-light);
  border-radius: 6rem;
  transition: all 1s ease;
  font-weight: 700;
}

.menu-contact-info {
  margin: 1rem 0 0 0;
  font-size: 1.2rem;
  text-align: center;
}
.menu-contact-info p {
  margin: 1rem 0;
}

.menu-contact-info a {
  color: var(--text-color-dark);
  font-size: 1.2rem;
  text-transform: none;
}
.menu-contact-info a:hover {
  text-decoration: underline;
  color: var(--accent-gold);
  text-transform: uppercase;
  transition: all 1s ease;
}

.desktop-nav {
  background-color: var(--secondary-color);
}

.hamburger-menu {
  cursor: pointer;
  padding: 0.5rem;
  z-index: 99999 !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 60px;
  height: 40px;
  position: relative;
  gap: 2px;
  padding-right: 1rem;
}

.bar {
  display: block;
  background-color: var(--accent-orange);
  width: 100%;
  height: 5px;
  transition: all 0.2s ease-in-out;
  transform-origin: left center;
  border-radius: 10px;
  position: relative;
}

.hamburger-menu.open .bar:nth-child(1) {
  transform: rotate(45deg) translate(5px, -8px);
}

.hamburger-menu.open .bar:nth-child(2) {
  opacity: 0;
  transform: translateX(-10px);
}

.hamburger-menu.open .bar:nth-child(3) {
  transform: rotate(-45deg) translate(3px, 9px);
}

/* Slide transition */
.slide-enter-active {
  animation: slideIn 0.7s ease;
  transition: all 0.7s ease-in;
}

.slide-enter,
.slide-leave-to {
  animation: slideOut 0.7s ease-out;
  -webkit-animation: slideOut 0.7s ease-in-out forwards;
  -moz-animation: slideOut 0.7s ease-in-out forwards;
  -o-animation: slideOut 0.7s ease-in-out forwards;
  -ms-animation: slideOut 0.7s ease-in-out forwards;
  transition: all 0.7s ease-out;
}
.slide-leave-active {
  animation: slideOut 0.7s ease;
  transition: all 0.7s ease-out;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.logo {
  width: 250px;
  height: auto;
}

.social-media a {
  margin: 0 1rem;
}
.social-media a:hover {
  padding: 0;
  background-color: transparent;
}

@keyframes slideIn {
  from {
    width: 0%;
  }
  to {
    width: 50%;
  }
}
@keyframes slideOut {
  from {
    width: 50%;
  }
  to {
    width: 0%;
  }
}
</style>
